<script setup lang="ts">
const props = defineProps({
    label: {
        type: String,
        required: true
    },
    value: {
        type: String
    },
})

const emit = defineEmits(['change'])

const onChangeTypeButton = (event: any) => {
    emit('change', {
        target: 'type-button',
        value: event.target.value
    })
}

const options = [
    {
        id: 1,
        value: 'url',
        label: 'URL'
    },
    {
        id: 2,
        value: 'whatsapp',
        label: 'Whatsapp'
    },
]
</script>

<template>
    <div class="space-y-3">
        <div class="space-y-2">
            <span class="text-sm font-semibold text-[#060606] opacity-50">
                {{ label }}
                
            </span>

            <div class="w-full">
                <select
                    @change="onChangeTypeButton"
                    class="w-full text-sm bg-[#fcfcfc] outline-none appearance-none px-4 py-3 rounded border-[#F5F5F5] border-2"
                    id="open-in"
                >
                    <option
                        v-for="option in options"
                        :key="option.id"
                        :value="option.value"
                        :selected="option.value == value"
                    >
                        {{ option.label }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
